import styled from 'styled-components';

export const NavPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  h2 {
    margin: 10px 0;
  }
`;
